import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ApiUrlGuard, View, viewResolver } from '@lib/core';
import { LayoutModule } from '@lib/layout';
import { MissingPermissionComponent } from '@lib/util';
import { MainComponent } from './app/main.component';
import { InsertApiUrlComponent } from './app/insert-api-url/insert-api-url.component';
import { InvalidApiUrlComponent } from './app/invalid-api-url/invalid-api-url.component';
import { OciRedirectionComponent } from '@lib/oci';

const routes: Routes = [
    {
        path: 'insert-api-url',
        component: InsertApiUrlComponent,
    },
    {
        path: 'no-server-connection',
        component: InvalidApiUrlComponent,
    },
    {
        path: 'oci-punch-out/open',
        component: OciRedirectionComponent,
    },
    {
        path: 'authenticate',
        loadComponent: () => import('@lib/auth').then((m) => m.AutomaticLoginComponent),
    },
    {
        path: 'password-reset/request',
        loadComponent: () => import('@lib/auth').then((m) => m.PasswordResetRequestComponent),
    },
    {
        path: 'password-reset',
        loadComponent: () => import('@lib/auth').then((m) => m.PasswordResetComponent),
    },
    {
        path: '',
        component: MainComponent,
        canActivate: [ApiUrlGuard],
        children: [
            {
                path: View.CLIENT,
                loadChildren: () => import('@lib/client-view').then((m) => m.ClientViewModule),
                resolve: { view: viewResolver },
                data: {
                    view: View.CLIENT,
                },
            },
            {
                path: 'missing-permission',
                component: MissingPermissionComponent,
            },
            {
                path: '**',
                redirectTo: `${View.CLIENT}/home`,
            },
        ],
    },
];

@NgModule({
    imports: [LayoutModule, RouterModule.forRoot(routes, {})],
    exports: [RouterModule],
})
export class AppRoutingModule {}
